import React from 'react'

export function FormLabel(props: {children: React.ReactNode}) {
  return (
    <label style={{
        fontWeight: '700',
        fontSize: '16px'
    }}>
        {props.children}
    </label>
  )
}
